import React from "react";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import moment from 'moment';

import Global from "../util/Global";
const AddForum = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  var height = window.innerHeight;
  var width = window.innerWidth;
  const FORUM_URL = Global.backend + "/index.php/forum/nouveauForum";
  const Last_FORUM_URL = Global.backend + "/index.php/forum/allCategories";
  const FORUM = Global.backend + "/index.php/forum/forumbycategorie";

  const [lastForum, setLastForum] = useState([]);



  const [playOnce, setPlayOnce] = useState(false);

  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [categorie, setCategorie] = useState("");
  const [forumList, setForumList] = useState([]);

  function fetchForumList() {



    setIsLoading(true);



    axios
      .post(FORUM, {
        categorie: 1
      })
      .then((response) => {
        console.log(response.data);
        setForumList(response.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }




  function fetchAllCategorieForum() {
    axios
      .get(Last_FORUM_URL)
      .then((response) => {

        console.log(response.data);

        setLastForum(response.data);
      })
      .finally(() => {

      });
  }



  useEffect(() => {
    if (!playOnce) {


      fetchAllCategorieForum();
      fetchForumList();

      setPlayOnce(true);
    }
  }, [lastForum]);


  function fetchAddForum() {

    if (localStorage.getItem('id') == null) {

      Swal.fire({
        title: t('contact3.1'),
        text: t('forumadd.1'),
        icon: "error",
        confirmButtonText: "OK",
      });



    } else {






      setIsLoadings(true);
      axios
        .post(FORUM_URL, {
          titre: titre,
          description: description,
          categorie: categorie,
          userId: localStorage.getItem('id')
        })
        .then((response) => {
          console.log("message : " + response.data.message);
          if (response.data.message == "ok") {
            Swal.fire({
              title: t('contact1.1'),
              text: t("forumadd2.1"),
              icon: "success",
              confirmButtonText: "OK",
            });
            setTitre("");
            setDescription("");
            setCategorie("");
            setIsLoadings(false);
          } else {
            Swal.fire({
              title: "Error",
              text: t("forumadd3.1"),
              icon: "error",
              confirmButtonText: "OK",
            });
            setIsLoadings(false);
          }
        })
        .finally(() => {
          setIsLoadings(false);
          // okAlert();
        });

    }
  }

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1
  };




  const activities = [
    "pêche",
    "aquaculture",
    "élevage",

    "transport et logistique",
    "distribution",

    "restauration",
    "matériels et équipements",
    "bateaux et mécanique",
    "maintenance et entretien",
    "autres"



  ]










  return (
    <div>



      {isLoadings && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 100000,
            height: height,
          }}
        >
          <CircularProgress color="primary" size={80} />
        </div>
      )}


      <>

        {isLoading && (
          <div className="scene">
            <div className="plane">
              <div className="cube cube--0">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--0"></div>
              <div className="cube cube--1">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--1"></div>
              <div className="cube cube--2">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--2"></div>
              <div className="cube cube--3">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--3"></div>
              <div className="cube cube--4">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--4"></div>
              <div className="cube cube--5">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--5"></div>
              <div className="cube cube--6">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--6"></div>
              <div className="cube cube--7">
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
                <div className="cube__side"></div>
              </div>
              <div className="shadow shadow--7"></div>
            </div>
          </div>
        )}




        {!isLoading && (









          <div className="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-grey clearfix">
            <div className="container">






              <div className="row" style={{ marginTop: 20 }}>





                <div className="col-md-12" style={{ width: "100%", paddingLeft: 0, marginLeft: 0 }}>

                  <div id="breadcrumb" className="breadcrumb" style={{ paddingLeft: 0, marginLeft: 0 }}>
                    <ul className="floatcontainer" style={{ paddingLeft: 0, marginLeft: 0 }}>
                      <li className="navbithome">
                        <a >
                          <img src={require("../assets/FrontOffice/images/navbit-home.png")} alt="Accueil" title="Accueil" />
                        </a>
                      </li>


                      <li className="navbit"><a >Forum</a></li>
                      <li className="navbit lastnavbit"><a >{t('forumadd4.1')}</a></li>




                    </ul>
                    <hr />
                  </div>

                </div>

















                <div className="col-lg-8">
                  <article className=" clearfix">


                    <div className=" clearfix">
                      <div id="comments" className="comments-area" style={{ paddingTop: 0 }}>
                        <div className="comment-respond">
                          <h3 className="comment-reply-title" style={{ fontSize: 18, fontWeight: "bold" }}>{t("forumadd5.add")}</h3>




                          <p className="comment-form-comment">
                            <select style={{ backgoundColor: "#f3f5ff" }}

                              defaultValue={categorie}
                              onChange={(e) => setCategorie(e.target.value)}





                            >

                              <option value="" disabled={true}>
                                {t("forumadd6.add")}
                              </option>
                              {lastForum.map((o, index) => (
                                <option key={o.id} value={o.id}>
                                  {o.nom}
                                </option>
                              ))}
                            </select>
                          </p>
                          <p className="comment-form-comment">
                            <input id="comment" placeholder={t("forumadd7.add")} defaultValue={titre}
                              onChange={(e) => setTitre(e.target.value)} name="Titre" type="text" />
                          </p>
                          <p className="comment-form-comment">
                            <textarea id="comment"
                              defaultValue={description}
                              onChange={(e) => setDescription(e.target.value)}

                              placeholder={t("forumadd8.add")} name="comment" cols="45" rows="7" aria-required="true"></textarea>
                          </p>



                          <p className="form-submit margin_top30 margin_bottom0">





                            <input className="blackbutton" name="rech_annuaire" type="button" onClick={() => { fetchAddForum() }} value={t("forumadd9.add")} />

                          </p>

                        </div>
                      </div>
                    </div>
                  </article>
                </div>


                <div className="col-md-4">
                  <div className="ttm-bgcolor-white  border-rad_5 margin_top15" style={{ padding: 10 }}>

                    <h2 className="title" style={{ fontSize: 18, fontWeight: "bold" }}>{t("forumadd10.add")}
                    </h2>

                    <table className="ui topics stackable striped table" style={{ border: "none" }}>

                      <tbody>

                        {forumList

                          .map((c, index) => (
                            <tr className="hoverable" style={{ border: "none" }} key={index}>
                              <td className="topic">
                                <NavLink to={`/forums/${c.user.nom}/${c.user.id}`}>
                                  <img className="img-fluid auto_size ui circular mini image user left floated lazyload clickable transition visible"
                                    style={{ width: 40, height: 40 }} src={require("../assets/FrontOffice/images/avatar.png")} />

                                </NavLink>
                                <NavLink to={`/detail/${c.id}`}>
                                  <a className="titleforum">{c.titre}</a>
                                </NavLink>

                                <span className="date">
                                  <i className="fa fa-clock-o" style={{ color: "#7089a9" }}></i> {moment(c.date).fromNow()}
                                </span>
                                <p className="preview">
                                  {c.description}
                                </p>
                              </td>

                            </tr>




                          ))}












                      </tbody>

                    </table>
                  </div>
                </div>



              </div>
            </div>
          </div>

        )}
      </>

      <Footer />
    </div>
  );
};

export default AddForum;